/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";

export default function ApplicationError() {
    const location = useLocation();
    return (
        <Container>
            <Typography>
                <FormattedMessage
                    id="application.error.description"
                    defaultMessage="{value} doesn't exist"
                    values={{
                        value: location.pathname,
                    }}
                />
            </Typography>
        </Container>
    );
}
